export function RoleSelect(){
    return (<div>
        <h1>Select Role</h1>
        <a href="/publisher/">Publisher</a>
        <a href="/subscriber/">Subscriber</a>
        </div>
    );
}